import { makeFilterParams } from '../../utils/helpers/helpers';
import httpClient from '../httpClient';

const contractsTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(
      `/ct_certification_contractor_contract/export/?${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/ct_certification_contractor_contract/?page[number]=${page}&page[size]=${pageSize}&${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
    );
};

const getContractDetails = async (id) => {
  return await httpClient.get(`/ct_certification_contractor_contract/${id}`);
};

const certificatesTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(
      `/ct_certification_contractor/export/?${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/ct_certification_contractor/?page[number]=${page}&page[size]=${pageSize}&${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
    );
};

const post = async (data) => {
  return await httpClient.post('/ct_certification_contractor/', data);
};

const get = async (id) => {
  return await httpClient.get(`/ct_certification_contractor/${id}`);
};

const generalCertificatesTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(
      `/ct_certification_contractor_general/export/?${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/ct_certification_contractor_general/?page[number]=${page}&page[size]=${pageSize}&${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
    );
};

const generalCertificatesOrganizations = async (tercero_id) => {
  return await httpClient.get(
    '/ct_general_certification_contractor_contract/organizations/',
    {
      params: {
        'filter[tercero]': tercero_id,
      },
    },
  );
};

const generalCertificatesContractTable = async (
  query,
  page = 1,
  pageSize = 10,
) => {
  return await httpClient.get(
    `/ct_general_certification_contractor_contract/?page[number]=${page}&page[size]=${pageSize}`,
    makeFilterParams(query),
  );
};

const postGeneral = async (data) => {
  return await httpClient.post('/ct_certification_contractor_general/', data);
};

const getGeneral = async (id) => {
  return await httpClient.get(`/ct_certification_contractor_general/${id}`);
};

export {
  contractsTable,
  getContractDetails,
  certificatesTable,
  post,
  get,
  generalCertificatesTable,
  generalCertificatesOrganizations,
  generalCertificatesContractTable,
  postGeneral,
  getGeneral,
};
